import { useEffect, useState } from "react";
import { mailboxApi } from "@/lib/api";

export const notifyMailboxChanged = () => window.dispatchEvent(new Event("mailbox-changed"));

export function useMailboxBadge(enabled = true) {
  const [badge, setBadge] = useState({ pending: 0, unassigned: 0 });
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => mailboxApi.badge().then((r) => setBadge(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("mailbox-changed", load);
    return () => { clearInterval(t); window.removeEventListener("mailbox-changed", load); };
  }, [enabled]);
  return badge;
}

export function MailboxNavBadge({ badge, compact = false }) {
  if (!badge?.pending) return null;
  const n = (v) => (v > 99 ? "99+" : v);
  const title = `${badge.pending} unbearbeitete Mail${badge.pending === 1 ? "" : "s"}, davon ${badge.unassigned} ohne Zuordnung`;
  if (compact) {
    return (
      <span title={title} className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 flex items-center justify-center text-[10px] font-bold rounded-full bg-[#E8700A] text-white" data-testid="nav-collapsed-mailbox-badge">
        {badge.pending > 9 ? "9+" : badge.pending}
      </span>
    );
  }
  return (
    <span className="ml-auto mr-5 relative shrink-0" title={title}>
      <span className="min-w-[20px] h-5 px-1.5 flex items-center justify-center text-[11px] font-bold rounded-full bg-red-500 text-white" data-testid="nav-mailbox-pending-badge">{n(badge.pending)}</span>
      {badge.unassigned > 0 && (
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-amber-400 ring-2 ring-background" data-testid="nav-mailbox-unassigned-badge" aria-label={`${badge.unassigned} ohne Zuordnung`} />
      )}
    </span>
  );
}
